/* eslint-disable */

export interface MailAccountGetMessageDetailResponseDto {
  subject: string;
  sentOn: Date | null;
  errorMessage: string | null;
  status: string;
  from: string;
  to: string;
  contentHtml: string | null;
  contentText: string;
}

export const fixMailAccountGetMessageDetailResponseDtoFromJson = (dto?: MailAccountGetMessageDetailResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.sentOn = dto.sentOn && new Date(dto.sentOn);
};

export const fixMailAccountGetMessageDetailResponseDtoToJson = (dto?: MailAccountGetMessageDetailResponseDto | null): void => {
  if (!dto) {
    return;
  }
};
